module.exports = __webpack_public_path__ + "static/media/tpl-guide.cc7d5b4c.pdf";